(ns practitest.frontend.forms3.run.subs
  (:require
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::parent-instance
  (fn [db _]
    (get-in db [:entity :run :parent-instance])))

(re-frame/reg-sub
  ::parent-testset
  (fn [db _]
    (get-in db [:entity :run :parent-testset])))

(re-frame/reg-sub
  ::parent-test
  (fn [db _]
    (get-in db [:entity :run :parent-test])))

(re-frame/reg-sub
  ::navigation-data
  (fn [db _]
    (get-in db [:entity :run :navigation])))

(re-frame/reg-sub
  ::elapsed
  (fn [db _]
    (get-in db [:entity :run :timer :elapsed] 0)))

(re-frame/reg-sub
  ::running?
  (fn [db _]
    (get-in db [:entity :run :timer :running?] false)))

(re-frame/reg-sub
  ::time-management-enabled?
  :<- [::subs/current-project]
  (fn [project _]
    (:time_management_support project false)))

(re-frame/reg-sub
  ::steps-loading?
  (fn [db _]
    (get-in db [:entity :run :steps :loading?] false)))

(re-frame/reg-sub
  ::preconditions
  (fn [db _]
    (get-in db [:entity :run :steps :preconditions])))

(re-frame/reg-sub
  ::step-runs
  (fn [db _]
    (get-in db [:entity :run :steps :step-runs])))

(re-frame/reg-sub
  ::steps-dirty?
  (fn [db _]
    (get-in db [:entity :run :steps :dirty?] false)))

;; Editing state is tracked per-step (a set of step-ids currently being
;; edited), since steps can independently enter/exit edit mode - a single
;; shared boolean would let saving one step clobber another step's in-progress
;; edit state. This sub keeps the same "is any step being edited" boolean
;; semantics external callers (run.cljs, steps-dirty-or-editing?) already rely on.
(re-frame/reg-sub
  ::step-editing?
  (fn [db _]
    (boolean (seq (get-in db [:entity :run :steps :editing-step-ids])))))

(re-frame/reg-sub
  ::step-saving?
  (fn [db [_ step-id]]
    (contains? (get-in db [:entity :run :steps :saving-step-ids] #{}) step-id)))

(re-frame/reg-sub
  ::step-being-edited?
  (fn [db [_ step-id]]
    (contains? (get-in db [:entity :run :steps :editing-step-ids] #{}) step-id)))

(re-frame/reg-sub
  ::steps-dirty-or-editing?
  :<- [::steps-dirty?]
  :<- [::step-editing?]
  (fn [[dirty? editing?] _]
    (or dirty? editing?)))

(re-frame/reg-sub
  ::steps-dirty-fields
  :<- [::steps-dirty-or-editing?]
  (fn [dirty-or-editing? _]
    (if dirty-or-editing? [:dirty] [])))

(re-frame/reg-sub
  ::pending-edit-step-id
  (fn [db _]
    (get-in db [:entity :run :steps :pending-edit-id])))

(re-frame/reg-sub
  ::unsynced-warning
  (fn [db _]
    (get-in db [:entity :run :unsynced-warning])))

(re-frame/reg-sub
  ::link-issues-target-step-id
  (fn [db _]
    (get-in db [:entity :run :steps :link-issues-target-step])))

(re-frame/reg-sub
  ::link-issue-by-id-modal-open?
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-modal-open?] false)))

(re-frame/reg-sub
  ::link-issue-by-id-error
  (fn [db _]
    (get-in db [:entity :run :steps :link-issue-by-id-error])))

(re-frame/reg-sub
  ::unlink-issue-confirm-target-id
  (fn [db _]
    (get-in db [:entity :run :steps :unlink-confirm-target-id])))
